import type React from "react";
import { Link } from "react-router-dom";

const MainVisual: React.FC = () => {
	return (
		<section className="bg-white rounded-lg shadow-md mb-8 p-4 md:p-8">
			<div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center">
				<img
					src="/images/mokumoku-logo.png"
					alt="大船渡もくもく会"
					className="w-full md:w-1/2 h-auto mb-4 md:mb-0 md:mr-8"
				/>
				<div className="text-center md:text-left">
					<h1 className="text-3xl md:text-4xl font-bold text-blue-600 mb-4">
						大船渡もくもく会へようこそ
					</h1>
					<div className="text-gray-700 mb-4">
						<p className="mb-2">
							大船渡もくもく会は、地域の人々が集まり、自己学習や個人プロジェクトに取り組む場所です。プログラミング、デザイン、ライティングなど、様々な分野で自由に学習できます。
						</p>
						<p>
							初心者から経験者まで、誰でも参加できます。一人で学ぶのではなく、同じ志を持つ仲間と一緒に成長しましょう。
						</p>
					</div>
					<Link
						to="/signup"
						className="inline-block bg-blue-600 text-white font-bold py-2 px-6 rounded-full hover:bg-blue-700 transition duration-300"
					>
						もくもく会に参加する
					</Link>
				</div>
			</div>
		</section>
	);
};

export default MainVisual;
